import { Controller } from "@hotwired/stimulus"
import { Loggable } from "./concerns/loggable"
import { Dismissable } from "./concerns/dismissable"
import { ShowHide } from "./concerns/showHide"
import { usePwaHelpers } from "./concerns/use_pwa_helpers"
import { registerServiceWorker } from "../service_worker_registration"

// Connects to data-controller="web-push-subscribe"
// @see Notification.permission : https://developer.mozilla.org/en-US/docs/Web/API/Notification/permission_static
export default class extends Controller {

  static targets = ["enableButton", "successMessage", "failureMessage"]

  initialize() {
    Loggable(this, {debug: false})
    Dismissable(this, {})
    ShowHide(this, { hiddenClassName: "d-none" })
    usePwaHelpers(this)
  }

  connect() {
    this.log("connected")
    if (this.wasDismissed()) {
      this.log("user dismissed")
      this.hide(this.element)
    } else {
      if (this.isInstalled()) {
        this.registerServiceWorker()
        this.showNotification()
      } else {
        this.log("not installed")
        this.hide(this.element)
      }
    }
  }

  registerServiceWorker(){
    return registerServiceWorker()
      .then(registration => {
        if (registration) this.log("service worker registered", registration)
        return registration
      })
      .catch(error => this.error(`service worker registration failed: ${error}`))
  }

  showNotification(){
    if (!navigator.serviceWorker || !window.PushManager || !Notification) {
      this.log("notifications not supported by this browser")
      this.hide(this.element)
    } else if (Notification.permission !== "default") {
      this.log("notifications already granted or denied")
      this.hide(this.element)
    } else {
      this.log("notifications neither granted nor denied")
      // me ha pasado que me muestre el botón aunque ya autorizó.
      // por eso, chequeo si ya está suscripto
      this.checkCurrentSubscription().then(subscribed => {
        if (subscribed) {
          this.log("but subscription is already registered")
          this.hide(this.element)
        } else {
          this.log("showing enable button")
          this.show(this.element)
        }
      })
    }
  }

}
